module.exports = __webpack_public_path__ + "static/media/individual.c740e7c6.svg";